/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum ManageOrganizationTabs {
  General,
  Projects,
  Clusters,
  Members,
  Teams,
  SSO,
}

export const tabToRouteBinding = {
  [ManageOrganizationTabs.General]: {
    route: '',
    tab: '',
  },
  [ManageOrganizationTabs.Projects]: {
    route: 'projects',
    tab: 'projects',
  },
  [ManageOrganizationTabs.Clusters]: {
    route: 'clusters',
    tab: 'clusters',
  },
  [ManageOrganizationTabs.Members]: {
    route: 'members',
    tab: 'members',
  },
  [ManageOrganizationTabs.Teams]: {
    route: 'teams/:teamIdentifier?',
    tab: 'teams',
  },
  [ManageOrganizationTabs.SSO]: {
    tab: 'sso',
    route: 'sso',
  },
};
